/* eslint-disable import/prefer-default-export */
export const statisticType = {
  CURRENT: 'cur',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};



// WEBPACK FOOTER //
// ./src/constants/statistic.js